export default __webpack_public_path__ + "static/media/icon-video-muted.39a1b881.svg";